import { IoMdRemoveCircle } from "react-icons/io";
import { useDispatch } from "react-redux";
import {
  removePodcastFromPlaylist,
  removePodcastFromPlaylistLoading,
  removeSongFromPlaylist,
  removeSongFromPlaylistLoading,
  setCurrentAudio,
  setCurrentPodcast,
} from "redux/AudioPlayerRedux";

function PlaylistCard({
  song,
  currentSong,
  index,
  music,
  radio,
  podcast,
}: // QueueCount,
any) {
  const dispatch = useDispatch<any>();

  const isActive = currentSong?.id === song?.id;

  const chooseSong = () => {
    if (music) {
      dispatch(setCurrentAudio(song));
    } else if (podcast) {
      dispatch(setCurrentPodcast(song));
    }
  };

  const handleDelete = async () => {
    if (music) {
      const obj = { songId: song.id, index: index };
      await dispatch(removeSongFromPlaylistLoading());
      await dispatch(removeSongFromPlaylist(obj));
    } else if (podcast) {
      const obj = { songId: song.id, index: index };
      await dispatch(removePodcastFromPlaylistLoading());
      await dispatch(removePodcastFromPlaylist(obj));
    }
  };

  const artwork = music
    ? song?.artwork_url
    : podcast
    ? song?.podcast?.artwork_url
    : "";

  const artistName = music
    ? song?.artists?.[0]?.name
    : podcast
    ? song?.artist?.name
    : "";

  return (
    <>
      {song && (
        <div
          className={`group flex items-center gap-3 rounded-xl px-2 py-2 transition-colors duration-200 ${
            isActive ? "bg-white/[0.07]" : "hover:bg-white/[0.05]"
          }`}
        >
          {/* thumbnail (click to play) */}
          <div
            className="relative h-14 w-14 shrink-0 cursor-pointer overflow-hidden rounded-lg bg-white/5"
            onClick={chooseSong}
          >
            {artwork && (
              <img
                src={artwork}
                alt={song?.title || "artwork"}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover"
              />
            )}
          </div>

          {/* title + artist (click to play) */}
          <div
            className="flex min-w-0 flex-1 cursor-pointer flex-col"
            onClick={chooseSong}
          >
            <p
              className={`truncate text-[14px] font-semibold ${
                isActive ? "text-red-500" : "text-white"
              }`}
            >
              {song?.title}
            </p>
            <p className="truncate text-[12px] text-[#7B9DB4]">{artistName}</p>
          </div>

          {/* remove */}
          <button
            className="shrink-0 text-xl text-white/40 opacity-0 transition-colors duration-200 hover:text-red-500 group-hover:opacity-100"
            onClick={handleDelete}
            aria-label="Remove from queue"
          >
            <IoMdRemoveCircle />
          </button>
        </div>
      )}
    </>
  );
}

export default PlaylistCard;